import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFindNear = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.61982 17.15C3.67982 15.8 3.12981 14.22 3.01981 12.58C2.90981 10.94 3.25981 9.30003 4.01981 7.84003C4.78981 6.38003 5.92982 5.15999 7.33982 4.29999C8.73982 3.44999 10.3598 3 12.0098 3C13.6598 3 15.2698 3.44999 16.6798 4.29999C18.0898 5.14999 19.2298 6.38003 19.9998 7.84003C20.7598 9.30003 21.1098 10.94 20.9998 12.58C20.8898 14.22 20.3398 15.8 19.3998 17.15",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.73001 14.29C8.26001 13.62 8 12.82 8 12C8 10.94 8.42001 9.92999 9.17001 9.17999C9.92001 8.42999 10.93 8.01001 11.99 8.01001C13.05 8.01001 14.06 8.42999 14.81 9.17999C15.56 9.92999 15.98 10.94 15.98 12C15.98 12.82 15.72 13.62 15.25 14.29",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 20.99V19.99C9 19.2 9.31 18.43 9.88 17.87C10.44 17.31 11.21 16.99 12 16.99C12.79 16.99 13.56 17.31 14.12 17.87C14.68 18.43 15 19.19 15 19.99V21",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgFindNear;
